export default __webpack_public_path__ + "static/media/routes_active.33d31586.svg";